export var ENTITY = "auth";
export var REDUCER_KEY = "AUTH_V2";
export var BASE_PATH_ENTITY = "auth";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
